import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getTestimonials } from "../lib/api";
import usePageMeta from "../hooks/usePageMeta";

export default function Testimonials() {
  usePageMeta({title:"Testimonials & Reviews",description:"Real client testimonials for Queen Cleopatra's erotic hypnosis practice - BIID, cross-dressing, sissy feminisation, panty fetish, trans confidence and more. Shared with consent.",path:"/testimonials"});
  const [items, setItems] = useState([]);
  useEffect(() => { getTestimonials().then(d => setItems(d.items || [])); }, []);

  return (
    <div data-testid="page-testimonials">
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="eyebrow mb-5">Reviews</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cream leading-[1] max-w-3xl">
          Whispers from the <em className="text-gold">salon</em>.
        </h1>
        <p className="mt-6 max-w-2xl text-cream/70 leading-relaxed">
          A small, curated selection of reflections shared by guests. Identities are kept to
          initials only. All testimonials are moderated and shared with consent.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pb-24">
        <div className="grid md:grid-cols-2 gap-px bg-[#c9a04b]/15">
          {items.map((t, i) => {
            const isLinked = t.has_full_page && t.slug;
            const Card = (
              <figure
                className={`bg-charcoal p-10 h-full flex flex-col justify-between ${
                  isLinked ? "group cursor-pointer transition-colors hover:bg-charcoal/70" : ""
                }`}
                data-testid={`tmn-${i}`}
              >
                <blockquote className="font-serif italic text-2xl md:text-3xl text-cream/90 leading-snug">
                  <span className="text-gold mr-1">“</span>{t.quote}<span className="text-gold ml-1">”</span>
                </blockquote>
                <div className="mt-8">
                  <figcaption className="flex flex-wrap items-center gap-3 text-xs uppercase tracking-[0.22em] text-cream/55">
                    <span className="text-gold">{t.initials}</span>
                    <span>·</span><span>{t.session_type}</span>
                    {t.date && (<><span>·</span><span>{t.date}</span></>)}
                  </figcaption>
                  {isLinked && (
                    <div
                      data-testid={`tmn-${i}-read-more`}
                      className="mt-5 text-xs uppercase tracking-[0.22em] text-gold group-hover:text-cream transition-colors"
                    >
                      Read the full story · interview →
                    </div>
                  )}
                </div>
              </figure>
            );
            return isLinked ? (
              <Link key={t.id || i} to={`/testimonials/${t.slug}`} className="block h-full">
                {Card}
              </Link>
            ) : (
              <div key={t.id || i} className="h-full">{Card}</div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
